export default __webpack_public_path__ + "static/media/loader.b310a089.gif";